<template>
  <div>
    <table-widget
      :items="items"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <!-- <template slot="buttons">
        <b-button v-if="manage" class="mx-2" variant="primary" v-b-modal.projects-modal @click="selectedProjects = null"><font-awesome-icon icon="plus"/> Manage Projects</b-button>
      </template> -->
      <template slot="content">
        <b-table
          striped
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          show-empty
          small
        >
          <template v-slot:cell(title)="data">
            <a :href="projectUrl + data.item.id" target="_blank">{{
              data.item.title
            }}</a>
          </template>
          <template v-slot:cell(primaryInvestigator)="data">
            {{ data.item.primaryInvestigator.firstName }}
            {{ data.item.primaryInvestigator.lastName }}
          </template>
          <template v-slot:cell(location)="data">
            {{ data.item.location }}
          </template>
          <template v-slot:cell(startDate)="data">
            {{ data.item.startDate | formatDate }}
          </template>
          <template v-slot:cell(endDate)="data">
            {{ data.item.endDate | formatDate }}
          </template>
          <template v-slot:cell(type)="data">
            {{ data.item.projectType.name }}
          </template>
          <template v-slot:cell(status)="data">
            {{ data.item.status.name }}
          </template>
          <template v-slot:cell(details)="data">
            <a :href="projectUrl + data.item.id" target="_blank">Details</a>
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import * as _ from "lodash";
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      form: {
        items: [],
      },
      fields: [
        { key: "title", sortable: true },
        { key: "primaryInvestigator", sortable: true },
        { key: "location", sortable: true },
        { key: "status", sortable: true },
        { key: "type", sortable: true },
        { key: "startDate", sortable: true },
        { key: "endDate", sortable: true },
        { key: "details", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      showForm: false,
      selectedProjects: null,
    };
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    manage: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },

  components: {
    "table-widget": TableWidget,
  },

  computed: {
    projectUrl: function () {
      return process.env.NODE_ENV !== "production"
        ? "https://communitypartnerships-dev.chs.asu.edu/projects/"
        : "https://communitypartnerships.chs.asu.edu/projects/";
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reset() {
      this.form.items = this.items;
    },
    displayItem(item) {
      return item.title;
    },
  },

  watch: {
    items: function () {
      if (this.items) {
        this.form.items = _.clone(this.items);
      }
    },
  },
  created() {
    if (this.items) {
      this.form.items = _.clone(this.items);
    }
  },
};
</script>

<style scoped>
.form-horizontal {
  font-size: 13px;
}

.award-badge {
  cursor: pointer;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

.award-list {
  font-size: 16px;
}
table {
  font-size: 10pt;
}
</style>
